import { IconArrowForward, IconDownload } from "../../../../assets/icons/icon";
import "./device-farm-banner.scss";
const DeviceFarmBanner = () => {
  return (
    <section className="device-farm-banner">
      <div className="w-1440">
        <div className="row">
          <div className="col-12 .col-lg-5	 banner-title">
            <h1 className="divider-24">akaAT Device Farm</h1>
            <p className="divider-32">
              Mobile remote testing is made easy with <br />
              {`{online devices}`} from akaAT, for any demand.
            </p>
            <a
              href={`https://akaat.com/wiki/`}
              target={"_blank"}
              rel="noreferrer"
            >
              <button className="banner-btn divider-60">
                Get started
                <IconArrowForward style={{ marginLeft: "8px" }} />
              </button>
            </a>

            {/* <img src={ImagePartners} alt="fireSpot" height={40} /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeviceFarmBanner;
